import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicModule } from 'ng-dynamic-component';
import { FormattingService } from './services/formatting.service';
import { CurrencyService } from './services/currency.service';
import { GaStateService } from './services/ga-state.service';
import { ScrollTargetDirective } from './scroll/scroll-target.directive';
import { FavouriteToggleComponent } from './favouritetoggle/favourite-toggle.component';
import { GaFormlyComponent } from './formly/ga-formly.component';
import { FormlyFieldValueComponent } from './formly/fields/formly-field-value.component';
import { FormlyFieldSelectComponent } from './formly/fields/formly-field-select.component';
import { FormlyHorizontalWrapperComponent } from './formly/wrappers/formly-horizontal-wrapper.component';
import { FormlyFieldInputComponent } from './formly/fields/formly-field-input.component';
import { FormlyFieldSelect2Component } from './formly/fields/formly-field-select2.component';
import { FormlyFieldTextareaComponent } from './formly/fields/formly-field-textarea.component';
import { FormlyFieldCheckboxComponent } from './formly/fields/formly-field-checkbox.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyType, GaFormlyService } from './formly/ga-formly.service';
import { LanguageDataService } from './language/language-data.service';
import { EditableTextComponent } from './editable-text/editable-text.component';
import { EditableTextDialogComponent } from './editable-text/editable-text-dialog.component';
import { NgbPopoverModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { GA1Service } from './ga1/ga1.service';
import { FormlyFieldSearchComponent } from './formly/fields/formly-field-search.component';
import { AuthService } from './services/auth/auth.service';
import { FormlyFieldGroupComponent } from './formly/fields/formly-field-group.component';
import { FormlyFieldRadioComponent } from './formly/fields/formly-field-radio.component';
import { FormlyFieldRadioButtonComponent } from './formly/fields/formly-field-radio-button.component';
import { GaFormlyUtil, showErrorValidation } from './formly/ga-formly.util';
import { FormlyFieldMultiselectComponent } from './formly/fields/formly-field-multiselect.component';
import { GaValidateService } from './formly/ga-validate.service';
import { FormlyFieldCustomComponent } from './formly/fields/formly-field-custom.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { FormlyFieldDateinputComponent } from './formly/fields/formly-field-dateinput.component';
import { FormlyFieldHiddenComponent } from './formly/fields/formly-field-hidden.component';
import { GaEventService } from './services/ga-event.service';
import { CopyToClipboardComponent } from './copy-to-clipboard/copy-to-clipboard.component';
import { BusyButtonDirective } from './busy-button/busy-button.directive';
import { HttpDataService } from './http/http-data.service';
import { CompanyDataService } from './company/company-data.service';
import { GridComponent } from './grid/grid.component';
import { GridColDirective } from './grid/grid-col.component';
import { GaFormlyValidatorService } from './formly/ga-formly-validator.service';
import { FormlyFieldLinkComponent } from './formly/fields/formly-field-link.component';
import { TextComponent } from './text/text.component';
import { CollapsibleSectionsComponent } from './collapsible-sections/collapsible-sections.component';
import { CollapsiblePaneComponent } from './collapse/collapsible-pane.component';
import { CollapseIndicatorComponent } from './collapse/collapse-indicator.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClipboardModule } from 'ngx-clipboard';
import { FileButtonComponent } from './file-upload/file-button.component';
import { FileUploadDialogComponent } from './file-upload/file-upload-dialog.component';
import { FileUploadService } from './file-upload/file-upload.service';
import { LovService } from './services/lov.service';
import { UrlService } from './browser/url.service';
import { BillingDataService } from './services/billing/billing-data.service';
import { GaMessageService } from './message/ga-message.service';
import { DefaultDialogComponent } from './message/dialogs/default-dialog.component';
import { Ga1DialogComponent } from './message/dialogs/ga1-dialog.component';
import { AnalyticsService } from './services/analytics.service';
import { ActivityIndicatorComponent } from './activity-indicator/activity-indicator.component';
import { DocumentDataService } from './document/document-data.service';
import { FormlyFieldFileUploadComponent } from './formly/fields/formly-field-file-upload.component';
import { WebshopDataService } from '../main/webshop/webshop-data.service';
import { WorkflowDataService } from './services/workflow/workflow-data.service';
import { ScrollService } from './scroll/scroll.service';
import { TCDataService } from './services/termsandconditions/tc-data.service';
import { MarginsDataService } from './services/margins/margins-data.service';
import { TranslationService } from './translation/translation.service';
import { FaqItemComponent } from './faq/faq-item.component';
import { FaqLinkComponent } from './faq/faq-link.component';
import { FaqPopupComponent } from './faq/faq-popup.component';
import { FaqPopupDialogComponent } from './faq/faq-popup-dialog.component';
import { TranslateDefaultPipe } from './translation/translate-default.pipe';
import { ResponsiveService } from './responsive/responsive.service';
import { IframeContainerComponent } from './iframe-container/iframe-container.component';
import { ReportWrapperComponent } from './report/report-wrapper.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { EditorConfigService } from './editor/editor-config.service';
import { BodyClassService } from './services/body-class.service';
import { TranslateLabelComponent } from './translation/translate-label.component';
import { FaqDataService } from './faq/faq-data.service';
import { ContactInfoComponent } from './contact/contact-info.component';
import { ListContactsComponent } from './contact/list-contacts.component';
import { InputFocusDirective } from './input-focus/input-focus.directive';
import { WizardWrapperComponent } from './wizard/wizard-wrapper.component';
import { WizardControlsComponent } from './wizard/wizard-controls.component';
import { WizardContentComponent } from './wizard/wizard-content.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgSelectHeaderComponent } from './ag-grid-components/ag-select-header.component';
import { GaAgGridComponent } from './ag-grid-components/ga-ag-grid.component';
import { FilterPipe } from './pipes/filter.pipe';
import { InvoiceDataService } from './invoice-info/invoice-data.service';
import { MultiselectNewOptionComponent } from './formly/fields/multiselect/multiselect-new-option.component';
import { DynamicComponentService } from './dynamic-component/dynamic-component.service';
import { DefaultDialogWrapperComponent } from './message/dialogs/default-dialog-wrapper.component';
import { NoDialogWrapperComponent } from './message/dialogs/no-dialog-wrapper.component';
import { ImageUploadComponent } from './file-upload/image-upload.component';
import { GA1MenuService } from './ga1/ga1-menu.service';
import { DualMultiSelectComponent } from './dual-multi-select/dual-multi-select.component';
import { ButtonAddonComponent } from './formly/addons/button-addon.component';
import { LinkAddonComponent } from './formly/addons/link-addon.component';
import { DefaultFormDialogComponent } from './message/dialogs/default-form-dialog.component';
import { WindowPropertiesService } from './services/window-properties.service';
import { BreakpointsService } from './services/breakpoints.service';
import { ReportGridService } from './report/report-grid.service';
import { GaDeferredService } from './services/ga-deferred.service';
import { BrowserVendorService } from './browser/browser-vendor.service';
import { InfoLinkComponent } from './info-link/info-link.component';
import { FillHeightDirective } from './fill-height/fill-height.directive';
import { TranslationHelperService } from './translation/translation-helper.service';
import { AgReportDocumentRendererComponent } from './ag-grid-components/ag-report-document-renderer.component';
import { CombinedDateComponent } from './combined-date/combined-date.component';
import { FormlyFieldCombinedDateComponent } from './formly/fields/formly-field-combined-date.component';
import { ReportFiltersUtil } from './report/report-filters-util.service';
import { FormlyAlertComponent } from './formly/components/formly-alert.component';
import { FormlyFieldNgSelectComponent } from './formly/fields/formly-field-ng-select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DragulaModule } from 'ng2-dragula';
import { ReorderImagesComponent } from './reorder-images/reorder-images.component';
import { SlickComponent } from './slick/slick.component';
import { FixedToBottomComponent } from './fixed-element/fixed-to-bottom.component';
import { GaWizardService } from './wizard/ga-wizard.service';
import { BrowselistsModule } from './browselists/browselists.module';
import { SubcompanyEditComponent } from './company/subcompany-edit.component';
import { CompanyGroupAddeditComponent } from './company/company-group-addedit.component';
import { InvoiceInfoComponent } from './invoice-info/invoice-info.component';
import { FileUploadManageComponent } from './file-upload/file-upload-manage.component';
import { MailNotificationsComponent } from './mail/mail-notifications.component';
import { FixedToTopComponent } from './fixed-element/fixed-to-top.component';
import { UiViewComponent } from './ui-router/ui-view.component';
import { FormatPipe } from './pipes/format.pipe';
import { EmbeddedReportComponent } from './report/embedded-report/embedded-report.component';
import { ResizeService } from './services/resize.service';
import { OrderSearchDataService } from './services/order/order-search-data.service';
import { LedgerDataService } from './services/ledger/ledger-data.service';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { BreadcrumbComponent } from './breadcrumbs/breadcrumb.component';
import { BreadcrumbService } from './breadcrumbs/breadcrumb.service';
import { ReportActionsComponent } from './report/actions/report-actions.component';
import { ReportActionsSubmitComponent } from './report/actions/report-actions-submit.component';
import { ReportWrapperService } from './report/report-wrapper.service';
import { ReportExportComponent } from './report/export/report-export.component';
import { ReportExportService } from './report/export/report-export.service';
import { ReportAggregationService } from './report/report-aggregation.service';
import { SelectReportColumnsComponent } from './report/columns/select-report-columns.component';
import { CCheckboxListComponent } from './c-checkbox-list/c-checkbox-list.component';
import { StoredReportDataService } from './report/stored-report-data.service';
import { MaxHeightDirective } from './max/max-height.directive';
import { SafePipe } from './pipes/safe.pipe';
import { TicketDataService } from './ticket/ticket-data.service';
import { SOWDataService } from './sow/sow-data.service';
import { ReportActionsService } from './report/actions/report-actions.service';
import { ReportActionsConfigService } from './report/actions/report-actions-config.service';
import { AddOrderCommentActionComponent } from './report/actions/components/add-order-comment-action.component';
import { AddOemActionComponent } from './report/actions/components/add-oem-action.component';
import { UpdateEolActionComponent } from './report/actions/components/update-eol-action.component';
import { AddStatusActionComponent } from './report/actions/components/add-status-action.component';
import { StatusPreconditionService } from './report/actions/preconditions/status-precondition.service';
import { ChangeInvoiceRateActionComponent } from './report/actions/components/change-invoice-rate-action.component';
import { ChangePaymentDateActionComponent } from './report/actions/components/change-payment-date-action.component';
import { ChangePaymentStatusActionComponent } from './report/actions/components/change-payment-status-action.component';
import { CopyInvoiceActionComponent } from './report/actions/components/copy-invoice-action.component';
import { CloseOrderPendingActionComponent } from './report/actions/components/close-order-pending-action.component';
import { MarkTransferredActionComponent } from './report/actions/components/mark-transferred-action.component';
import { ChangeGbdmActionComponent } from './report/actions/components/change-gbdm-action.component';
import { ChangeOdActionComponent } from './report/actions/components/change-od-action.component';
import { ChangeWebshopContactActionComponent } from './report/actions/components/change-webshop-contact-action.component';
import { SendSignupLinkActionComponent } from './report/actions/components/send-signup-link-action.component';
import { AddImagesActionComponent } from './report/actions/components/add-images-action.component';
import { AssignGenericUserActionComponent } from './report/actions/components/assign-generic-user-action.component';
import { GenericUserPreconditionService } from './report/actions/preconditions/generic-user-precondition.service';
import { PermissionsPreconditionService } from './report/actions/preconditions/permissions-precondition.service';
import { PermissionsActionComponent } from './report/actions/components/permissions-action.component';
import { MailFaqHandlerService } from './report/actions/handlers/mail-faq-handler.service';
import { UploadOrderDocumentActionComponent } from './report/actions/components/upload-order-document-action.component';
import { MailInvoiceHandlerService } from './report/actions/handlers/mail-invoice-handler.service';
import { SendMailHandlerService } from './report/actions/handlers/send-mail-handler.service';
import { OutgoingFeeInvoiceActionComponent } from './report/actions/components/outgoing-fee-invoice-action.component';
import { MainPendingActionComponent } from './report/actions/components/main-pending-action.component';
import { MainPendingCheckedActionComponent } from './report/actions/components/main-pending-checked-action.component';
import { ChangeInvoiceMailAddressActionComponent } from './report/actions/components/change-invoice-mail-address-action.component';
import { ChangeBpActionComponent } from './report/actions/components/change-bp-action.component';
import { ChangeBpPreconditionService } from './report/actions/preconditions/change-bp-precondition.service';
import { DownloadBpHandlerService } from './report/actions/handlers/download-bp-handler.service';
import { BatchBillingActionComponent } from './report/actions/components/batch-billing-action.component';
import { BpCatalogSelectionHandlerService } from './report/actions/handlers/bp-catalog-selection-handler.service';
import { Ga3FormHandlerService } from './report/actions/handlers/ga3-form-handler.service';
import { CustomRateInputComponent } from './report/actions/components/addons/custom-rate-input.component';
import { DashboardDataService } from './report/dashboard-data.service';
import { PermissionsConfigService } from './report/actions/components/helpers/permissions-config.service';
import { MultiFileUploadComponent } from './multi-file-upload/multi-file-upload.component';
import { SendMailComponent } from './send-mail/send-mail.component';
import { SendMailService } from './send-mail/send-mail.service';
import { SendMailDataService } from './send-mail/send-mail-data.service';
import { MailInvoiceComponent } from './mail-invoice/mail-invoice.component';
import { MailInvoiceService } from './mail-invoice/mail-invoice.service';
import { ChangeInvoiceTemplateActionComponent } from './report/actions/components/change-invoice-template-action.component';
import { SetDefaultOEMLocationContactActionComponent } from './report/actions/components/set-default-oem-location-contact-action.component';
import { SetOEMRankingActionComponent } from './report/actions/components/set-oem-ranking-action.component';
import { SetOEMProcessingShippingModeActionComponent } from './report/actions/components/set-oem-processing-shipping-mode-action.component';
import { BPProfilesOEMUtilService } from './bp-profiles/bp-profiles-oem-util.service';
import { OEMTierStatusPreconditionService } from './report/actions/preconditions/oem-tier-status-precondition.service';
import { ReportDataService } from './report/report-data.service';
import { ScrollSpyDirective } from './scroll/scroll-spy.directive';
import { ParentWidthDirective } from './parent-width/parent-width.directive';
import { EditableTextService } from './editable-text/editable-text.service';
import { AgTooltipComponent } from './ag-grid-components/ag-tooltip.component';
import { AgDetailComponent } from './ag-grid-components/ag-detail.component';
import { FormGridComponent } from './form-grid/form-grid.component';
import { AgCellEditorComponent } from './ag-grid-components/ag-cell-editor/ag-cell-editor.component';
import { AgCellEditorService } from './ag-grid-components/ag-cell-editor/ag-cell-editor.service';
import { SendInvoiceHandlerService } from './report/actions/handlers/send-invoice-handler.service';
import { ReportStyleService } from './report/report-style.service';
import { AgRichTextRendererComponent } from './ag-grid-components/ag-rich-text/ag-rich-text-renderer.component';
import { AgActionButtonRendererComponent } from './ag-grid-components/ag-action-button/ag-action-button-renderer.component';
import { ScrollAnchorDirective } from './scroll/scroll-anchor.directive';
import { ChangeSendingStatusActionComponent } from './report/actions/components/change-sending-status-action.component';
import { GA1FieldLabelService } from './ga1-field-label/ga1-field-label.service';
import { GA1FieldLabelDialogComponent } from './ga1-field-label/ga1-field-label-dialog.component';
import { AgContactInfoRendererComponent } from './ag-grid-components/ag-contact-info/ag-contact-info-renderer.component';
import { AgButtonDropdownRendererComponent } from './ag-grid-components/ag-button-dropdown/ag-button-dropdown-renderer.component';
import { AgButtonRendererComponent } from './ag-grid-components/ag-button/ag-button-renderer.component';
import { ContactDataService } from './contact/contact-data.service';
import { FormlyFieldArrayComponent } from './formly/fields/formly-field-array.component';
import { TransformNumberToCollectionsPipe } from './pipes/transform-number-to-collections.pipe';
import { SurveyQuestionsComponent } from './survey/survey-questions.component';
import { SurveyDataService } from './survey/survey-data.service';
import { SurveyQuestionsWrapperComponent } from './survey/survey-questions-wrapper.component';
import { BPProfilesLocationsDataService } from './bp-profiles/bp-profiles-locations-data.service';
import { GaAgGridService } from './ag-grid-components/ga-ag-grid.service';
import { TRANSPORTER_PROVIDERS } from './services/logger/transporters/transporters-config';
import { LoggerService } from './services/logger/logger.service';
import { RemoteLoggerDataService } from './services/logger/remote-logger-data.service';
import { MemoryStorageService } from './services/storage/memory-storage.service';
import { FaqLinksComponent } from './faq/faq-links.component';
import { HttpClientModule } from '@angular/common/http';
import { NgForTrackByPropDirective } from './track-by/track-by-prop.directive';
import { NgForTrackByIdDirective } from './track-by/track-by-id.directive';
import { TrackVisibilityDirective } from './track-visibility/track-visibility.directive';
import { GaWebStorageService } from './services/storage/ga-web-storage.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AgPaginationComponent } from './ag-grid-components/ag-pagination/ag-pagination.component';
import { AgCellValidatorService } from './ag-grid-components/ag-cell-validator/ag-cell-validator.service';
import { AgCellValidatorComponent } from './ag-grid-components/ag-cell-validator/ag-cell-validator.component';
import { InvoiceTemplatesComponent } from './invoice/templates/invoice-templates.component';
import { InvoiceTemplateDetailComponent } from './invoice/templates/invoice-template-detail.component';
import { InvoiceTemplatesDataService } from './invoice/templates/invoice-templates-data.service';
import { InvoiceTemplatesService } from './invoice/templates/invoice-templates.service';
import { InvoiceTemplatesFormattingService } from './invoice/templates/invoice-templates-formatting.service';
import { SearchInputComponent } from './search/search-input.component';
import { SearchResultComponent } from './search/search-results.component';
import { TicketGuideDialogService } from './services/ticket-guide/ticket-guide-dialog.service';
import { CountryDataService } from './location/country-data.service';
import { DateUtil } from './services/date.util';
import { CombinedDateMetadataService } from './combined-date/combined-date.metadata.service';
import { LanguageService } from './language/language.service';
import { FileUploadModule } from 'ng2-file-upload';
import { FileUploadPreviewDirective } from './multi-file-upload/file-upload-preview.directive';
import { MailNewWebshopActionComponent } from './report/actions/components/mail-new-webshop-action.component';
import { CookieService } from 'ngx-cookie-service';
import { ConnectionService } from './services/auth/connection.service';
import { AuthDataService } from './services/auth/auth-data.service';
import { MaxWidthDirective } from './responsive/max-width.directive';
import { UploadFilesDialogComponent } from './editor/upload-files-dialog.component';
import { TitleService } from './services/title.service';
import { UserDataService } from './user/user-data.service';
import { UIRouterModule } from '@uirouter/angular';
import { TranslateDataService } from './translation/translate-data.service';
import { HttpEtagService } from './http/http-etag.service';
import { GaUserService } from './services/ga-user.service';
import { UpdateDocumentTypeActionComponent } from './report/actions/components/update-document-type-action.component';
import { ComponentService } from './services/component.service';
import { AlertModule } from 'ngx-bootstrap/alert';
import { GaAlertComponent } from '@app/shared/alert/ga-alert.component';
import { ReportLayoutSettingsService } from '@app/shared/report/report-layout-settings.service';
import { FindPipe } from '@app/shared/pipes/find.pipe';
import { MailPriceConfirmationHandlerService } from './report/actions/handlers/mail-price-confirmation-handler.service';

@NgModule({
  declarations: [
    FavouriteToggleComponent,
    CopyToClipboardComponent,
    CombinedDateComponent,
    DatePickerComponent,
    UiViewComponent,
    WizardWrapperComponent,
    WizardControlsComponent,
    WizardContentComponent,
    GridComponent,
    GridColDirective,
    EmbeddedReportComponent,
    ReportActionsComponent,
    ReportActionsSubmitComponent,
    ReportExportComponent,
    SelectReportColumnsComponent,
    CCheckboxListComponent,
    MultiFileUploadComponent,
    FormGridComponent,
    SearchInputComponent,
    SearchResultComponent,
    InvoiceTemplatesComponent,
    InvoiceTemplateDetailComponent,

    // directives
    ScrollTargetDirective,
    ScrollSpyDirective,
    ParentWidthDirective,
    ScrollAnchorDirective,
    BusyButtonDirective,
    InputFocusDirective,
    FillHeightDirective,
    MaxHeightDirective,
    NgForTrackByPropDirective,
    NgForTrackByIdDirective,
    TrackVisibilityDirective,
    FileUploadPreviewDirective,
    MaxWidthDirective,

    // -- formly
    GaFormlyComponent,
    FormlyFieldValueComponent,
    FormlyFieldSelectComponent,
    FormlyHorizontalWrapperComponent,
    FormlyFieldInputComponent,
    FormlyFieldSelect2Component,
    FormlyFieldTextareaComponent,
    FormlyFieldCheckboxComponent,
    FormlyFieldSearchComponent,
    FormlyFieldGroupComponent,
    FormlyFieldRadioComponent,
    FormlyFieldRadioButtonComponent,
    FormlyFieldMultiselectComponent,
    FormlyFieldNgSelectComponent,
    FormlyFieldCustomComponent,
    FormlyFieldDateinputComponent,
    FormlyFieldHiddenComponent,
    FormlyFieldLinkComponent,
    FormlyFieldFileUploadComponent,
    FormlyFieldCombinedDateComponent,
    FormlyFieldArrayComponent,
    MultiselectNewOptionComponent,

    // formly components
    FormlyAlertComponent,

    // -- editable text
    EditableTextComponent,
    EditableTextDialogComponent,
    TextComponent,
    // --

    CollapsibleSectionsComponent,
    CollapsiblePaneComponent,
    CollapseIndicatorComponent,
    FileButtonComponent,
    FileUploadDialogComponent,
    FileUploadManageComponent,
    ImageUploadComponent,
    ActivityIndicatorComponent,
    TranslateLabelComponent,
    DualMultiSelectComponent,
    InfoLinkComponent,
    SlickComponent,
    FixedToTopComponent,
    FixedToBottomComponent,
    MailNotificationsComponent,
    SurveyQuestionsComponent,
    SurveyQuestionsWrapperComponent,
    GaAlertComponent,

    // dialogs
    DefaultDialogComponent,
    DefaultDialogWrapperComponent,
    NoDialogWrapperComponent,
    Ga1DialogComponent,
    GA1FieldLabelDialogComponent,

    FaqItemComponent,
    FaqLinkComponent,
    FaqLinksComponent,
    FaqPopupComponent,
    FaqPopupDialogComponent,
    IframeContainerComponent,
    ReportWrapperComponent,
    DefaultFormDialogComponent,
    ReorderImagesComponent,

    ContactInfoComponent,
    ListContactsComponent,
    SubcompanyEditComponent,
    CompanyGroupAddeditComponent,
    InvoiceInfoComponent,
    BreadcrumbsComponent,
    BreadcrumbComponent,
    SendMailComponent,
    MailInvoiceComponent,
    UploadFilesDialogComponent,

    // formly addons
    ButtonAddonComponent,
    LinkAddonComponent,

    // -- ag-grid components
    GaAgGridComponent,
    AgSelectHeaderComponent,
    AgReportDocumentRendererComponent,
    AgTooltipComponent,
    AgCellEditorComponent,
    AgCellValidatorComponent,
    AgRichTextRendererComponent,
    AgContactInfoRendererComponent,
    AgButtonDropdownRendererComponent,
    AgButtonRendererComponent,
    AgActionButtonRendererComponent,
    AgPaginationComponent,
    AgDetailComponent,

    // -- report actions
    AddOrderCommentActionComponent,
    AddOemActionComponent,
    UpdateEolActionComponent,
    AddStatusActionComponent,
    ChangeInvoiceRateActionComponent,
    ChangePaymentDateActionComponent,
    ChangePaymentStatusActionComponent,
    CopyInvoiceActionComponent,
    CloseOrderPendingActionComponent,
    MarkTransferredActionComponent,
    ChangeGbdmActionComponent,
    ChangeOdActionComponent,
    ChangeWebshopContactActionComponent,
    SendSignupLinkActionComponent,
    AddImagesActionComponent,
    AssignGenericUserActionComponent,
    PermissionsActionComponent,
    UploadOrderDocumentActionComponent,
    OutgoingFeeInvoiceActionComponent,
    MainPendingActionComponent,
    MainPendingCheckedActionComponent,
    ChangeInvoiceMailAddressActionComponent,
    ChangeBpActionComponent,
    BatchBillingActionComponent,
    ChangeInvoiceTemplateActionComponent,
    SetDefaultOEMLocationContactActionComponent,
    SetOEMRankingActionComponent,
    SetOEMProcessingShippingModeActionComponent,
    ChangeSendingStatusActionComponent,
    MailNewWebshopActionComponent,
    UpdateDocumentTypeActionComponent,

    // -- report actions addons
    CustomRateInputComponent,

    // pipes
    TranslateDefaultPipe,
    FilterPipe,
    FindPipe,
    FormatPipe,
    SafePipe,
    TransformNumberToCollectionsPipe
  ],
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    NgbTypeaheadModule,
    TooltipModule,
    FormlySelectModule,
    UIRouterModule,
    FormlyModule.forRoot({
      types: [
        {
          name: FormlyType.ARRAY,
          component: FormlyFieldArrayComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.VALUE,
          component: FormlyFieldValueComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.SELECT,
          component: FormlyFieldSelectComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.INPUT,
          component: FormlyFieldInputComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.SELECT2,
          component: FormlyFieldSelect2Component,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.TEXTAREA,
          component: FormlyFieldTextareaComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.SEARCH,
          component: FormlyFieldSearchComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.GROUP,
          component: FormlyFieldGroupComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.RADIO,
          component: FormlyFieldRadioComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.MULTI_SELECT,
          component: FormlyFieldMultiselectComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.NG_SELECT,
          component: FormlyFieldNgSelectComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.DATE_INPUT,
          component: FormlyFieldDateinputComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.COMBINED_DATE,
          component: FormlyFieldCombinedDateComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.CUSTOM,
          component: FormlyFieldCustomComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.HIDDEN,
          component: FormlyFieldHiddenComponent,
          wrappers: []
        },
        {
          name: FormlyType.RADIO_BUTTON,
          component: FormlyFieldRadioButtonComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.CHECKBOX,
          component: FormlyFieldCheckboxComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.LINK,
          component: FormlyFieldLinkComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        },
        {
          name: FormlyType.FILE_UPLOAD,
          component: FormlyFieldFileUploadComponent,
          wrappers: [ GaFormlyService.FIELD_HORIZONTAL_WRAPPER ]
        }
      ],
      wrappers: [
        {
          name: GaFormlyService.FIELD_HORIZONTAL_WRAPPER,
          component: FormlyHorizontalWrapperComponent
        }
      ],
      extras: {
        showError: showErrorValidation
      }
    }),
    AgGridModule,
    BrowserAnimationsModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    AlertModule.forRoot(),
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
    DragulaModule.forRoot(),
    EditorModule,
    DynamicModule,
    ClipboardModule,
    BrowselistsModule,
    FileUploadModule
  ],
  providers: [
    ...TRANSPORTER_PROVIDERS,
    // --
    GaStateService,
    CurrencyService,
    LanguageService,
    LanguageDataService,
    GA1Service,
    AuthService,
    AuthDataService,
    HttpDataService,
    HttpEtagService,
    TitleService,
    LovService,
    CookieService,
    UrlService,
    AnalyticsService,
    ScrollService,
    BodyClassService,
    ResponsiveService,
    EditorConfigService,
    GA1MenuService,
    ConnectionService,
    BrowserVendorService,
    UserDataService,
    TranslationService,
    TranslationHelperService,
    TranslateDataService,
    GaFormlyService,
    GaFormlyUtil,
    GaFormlyValidatorService,
    GaUserService,
    GaValidateService,
    GaEventService,
    GaMessageService,
    GaWizardService,
    FormattingService,
    FileUploadService,
    BillingDataService,
    DocumentDataService,
    WorkflowDataService,
    TCDataService,
    MarginsDataService,
    FaqDataService,
    InvoiceDataService,
    DynamicComponentService,
    WindowPropertiesService,
    ResizeService,
    BreakpointsService,
    ReportGridService,
    ReportStyleService,
    ReportWrapperService,
    ReportExportService,
    ReportAggregationService,
    ReportLayoutSettingsService,
    GaDeferredService,
    WebshopDataService,
    ReportDataService,
    ReportFiltersUtil,
    StoredReportDataService,
    LedgerDataService,
    BreadcrumbService,
    TicketDataService,
    SOWDataService,
    ReportActionsService,
    ReportActionsConfigService,
    DashboardDataService,
    SendMailService,
    SendMailDataService,
    MailInvoiceService,
    BPProfilesOEMUtilService,
    CompanyDataService,
    EditableTextService,
    AgCellEditorService,
    AgCellValidatorService,
    GA1FieldLabelService,
    ContactDataService,
    SurveyDataService,
    BPProfilesLocationsDataService,
    GaAgGridService,
    LoggerService,
    RemoteLoggerDataService,
    GaWebStorageService,
    MemoryStorageService,
    InvoiceTemplatesDataService,
    InvoiceTemplatesService,
    InvoiceTemplatesFormattingService,
    OrderSearchDataService,
    TicketGuideDialogService,
    CountryDataService,
    DateUtil,
    CombinedDateMetadataService,
    ComponentService,

    //-- report actions handlers
    MailFaqHandlerService,
    MailInvoiceHandlerService,
    SendMailHandlerService,
    BpCatalogSelectionHandlerService,
    DownloadBpHandlerService,
    Ga3FormHandlerService,
    SendInvoiceHandlerService,
    MailPriceConfirmationHandlerService,

    // -- report actions preconditions
    StatusPreconditionService,
    GenericUserPreconditionService,
    PermissionsPreconditionService,
    ChangeBpPreconditionService,
    OEMTierStatusPreconditionService,

    // -- report actions helpers
    PermissionsConfigService
  ],
  exports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    PopoverModule,
    DragulaModule,
    NgbTypeaheadModule,
    TooltipModule,
    UIRouterModule,
    TranslateModule,
    EditorModule,
    DynamicModule,
    BrowselistsModule,
    PaginationModule,

    // directive
    ScrollTargetDirective,
    ScrollSpyDirective,
    ParentWidthDirective,
    ScrollAnchorDirective,
    BusyButtonDirective,
    InputFocusDirective,
    FillHeightDirective,
    MaxHeightDirective,
    NgForTrackByPropDirective,
    NgForTrackByIdDirective,
    TrackVisibilityDirective,
    FileUploadPreviewDirective,
    MaxWidthDirective,

    // component
    FavouriteToggleComponent,
    CombinedDateComponent,
    DatePickerComponent,
    GaFormlyComponent,
    EditableTextComponent,
    EditableTextDialogComponent,
    GridComponent,
    GridColDirective,
    TextComponent,
    CollapsibleSectionsComponent,
    CollapsiblePaneComponent,
    CollapseIndicatorComponent,
    FileButtonComponent,
    ActivityIndicatorComponent,
    FaqItemComponent,
    FaqLinkComponent,
    FaqLinksComponent,
    IframeContainerComponent,
    ReportWrapperComponent,
    FaqPopupComponent,
    TranslateLabelComponent,
    DualMultiSelectComponent,
    ContactInfoComponent,
    UiViewComponent,
    WizardWrapperComponent,
    WizardControlsComponent,
    WizardContentComponent,
    GaAgGridComponent,
    ListContactsComponent,
    InfoLinkComponent,
    ReorderImagesComponent,
    SlickComponent,
    SubcompanyEditComponent,
    CompanyGroupAddeditComponent,
    InvoiceInfoComponent,
    FixedToTopComponent,
    FixedToBottomComponent,
    MailNotificationsComponent,
    EmbeddedReportComponent,
    SurveyQuestionsComponent,
    BreadcrumbsComponent,
    BreadcrumbComponent,
    ReportActionsComponent,
    ReportActionsSubmitComponent,
    ReportExportComponent,
    SelectReportColumnsComponent,
    CCheckboxListComponent,
    MultiFileUploadComponent,
    SendMailComponent,
    MailInvoiceComponent,
    FormGridComponent,
    SurveyQuestionsWrapperComponent,
    CopyToClipboardComponent,
    InvoiceTemplatesComponent,
    InvoiceTemplateDetailComponent,
    SearchResultComponent,
    UploadFilesDialogComponent,
    GaAlertComponent,

    // formly components
    FormlyAlertComponent,

    // dialogs
    DefaultDialogComponent,
    DefaultDialogWrapperComponent,
    NoDialogWrapperComponent,

    // pipes
    FilterPipe,
    FindPipe,
    FormatPipe,
    TranslateDefaultPipe,
    SafePipe,
    TransformNumberToCollectionsPipe,
    SearchInputComponent
  ]
})
export class SharedModule { }